<div class="flex w-full items-center justify-end border-b border-zinc-900/15 p-4 dark:border-white/10">
  <div (click)="showSurveySidebar(!!sideOpen)" class="mr-auto md:mr-0 md:hidden">
    <div *ngIf="isAuthenticated && !preSurveyState">
      <div *ngIf="!sideOpen" title="show survey navigation">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
      </div>
      <div *ngIf="sideOpen" title="hide survey navigation">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </div>
    </div>
  </div>
  <nav class="hidden gap-4 border-r border-zinc-900/15 px-4 md:flex dark:border-white/10">
    <a *ngFor="let page of pageNav" [routerLink]="page.route">
      {{ page.name }}
    </a>
  </nav>

  <!-- Theme toggle in Navbar -->
  <div class="flex items-center px-4">
    <svg *ngIf="isDarkMode" (click)="toggleTheme()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      stroke-width="1.5" stroke="currentColor" class="size-5 cursor-pointer">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" />
    </svg>
    <svg *ngIf="!isDarkMode" (click)="toggleTheme()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      stroke-width="1.5" stroke="currentColor" class="size-5 cursor-pointer">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z" />
    </svg>
  </div>

  <!-- user menu -->
  <div class="user-menu-container relative h-full">
    <div class="flex h-full items-center justify-center">
      <button (click)="toggleDropdown()" class="cursor-pointer" title="{{ user }}">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="h-6 w-6">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
      </button>
    </div>
    <div *ngIf="isOpen" [@flyoutAnimation]="isOpen ? 'open' : 'closed'"
      class="absolute right-0 z-50 mt-[1.063rem] flex flex-col gap-2 rounded-md border border-zinc-900/15 bg-white py-4 shadow-lg dark:border-white/10 dark:bg-zinc-900">
      <span class="cursor-default rounded-t-md border-b border-zinc-900/15 px-4 pb-3 font-bold dark:border-white/10">
        {{ user }}
      </span>
      <div class="flex flex-col px-4">
        <a (click)="openProfile()" class="cursor-pointer">Profile</a>
        <a class="group flex cursor-pointer text-sm" (click)="onLogout()">
          Logout
          <span class="flex items-center justify-center ps-1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="h-4 w-4 group-hover:scale-110">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
            </svg>
          </span>
        </a>
      </div>
    </div>
  </div>
</div>